import { saveAs } from 'file-saver';
import apiBase from 'src/api/api-base';
import { endpoints } from 'src/config/endpoints';

export type TemplateInfo = {
  exists: boolean;
  name: string | null;
  updated_at: string | null;
  size: number | null;
};

export const getTemplateInfo = async (): Promise<TemplateInfo> =>
  new Promise((resolve, reject) => {
    apiBase
      .get(endpoints.configuration.template)
      .then((response) => resolve(response.data as TemplateInfo))
      .catch(reject);
  });

export const uploadTemplate = async (file: File): Promise<void> => {
  const formData = new FormData();
  formData.append('template', file);
  await apiBase.post(endpoints.configuration.template, formData, {
    headers: { Accept: 'application/json' },
  });
};

export const downloadTemplate = async (): Promise<void> => {
  const response = await apiBase.get(endpoints.configuration.templateDownload, {
    responseType: 'blob',
  });
  saveAs(response.data, 'collaudo_template.xlsx');
};
